import { useServerData, LIST_MIN_LOADING_MS } from '@/hooks/useServerData';
import { PlatformFeeService } from '@/services/platformFee.service';
import type {
  PlatformFeeHistoryEntry,
  PlatformFeeOwnersPage,
  PlatformFeeOwnersQuery,
  PlatformFeeRateInfo,
} from '@/integrations/supabase/rpc-types';

/** Aliquota di chi chiama. `enabled` falso per i ruoli che non ne hanno una (traveler). */
export function useMyPlatformFeeRate(enabled = true) {
  return useServerData<PlatformFeeRateInfo | null>(
    'my-platform-fee-rate',
    null,
    () => PlatformFeeService.getMyRate(),
    enabled,
    0,
    // Un'anteprima che non si carica non merita un toast: chi la mostra ripiega.
    false
  );
}

/** Aliquota del viaggio. Senza id (itinerario non ancora salvato) non chiama nulla. */
export function useItineraryPlatformFeeRate(itineraryId: string | null | undefined) {
  return useServerData<PlatformFeeRateInfo | null>(
    `itinerary-platform-fee-rate:${itineraryId ?? ''}`,
    null,
    () => PlatformFeeService.getItineraryRate(itineraryId!),
    Boolean(itineraryId),
    0,
    false
  );
}

/** Pagina della tab Agenzie. `refreshKey` cambiato = ricarica con gli stessi filtri. */
export function usePlatformFeeOwners(query: PlatformFeeOwnersQuery, refreshKey: number) {
  return useServerData<PlatformFeeOwnersPage | null>(
    JSON.stringify({ query, refreshKey }),
    null,
    () => PlatformFeeService.getOwners(query),
    true,
    LIST_MIN_LOADING_MS
  );
}

export function usePlatformFeeHistory(ownerId: string | null, refreshKey: number) {
  return useServerData<PlatformFeeHistoryEntry[]>(
    JSON.stringify({ ownerId, refreshKey }),
    [],
    () => PlatformFeeService.getHistory(ownerId!),
    ownerId !== null
  );
}
